import(/* webpackMode: "eager" */ "/workspace/src/frontend/src/app/global-error.tsx");
